import coverImg from '../../../assets/images/literature/radio-poem-cover.jpg';

const SEGMENTS = [
    {
        id: 'radio-poem-1',
        title: 'The Little Box',
        text: `You little box, held to me escaping
So that your valves should not break
Carried from house to house to ship from sail to train,
So that my enemies might go on talking to me,
Near my bed, to my pain
The last thing at night, the first thing in the morning,
Of their victories and of my cares,
Promise me not to go silent all of a sudden.`,
        morseText: '| | | YOU LITTLE BOX HELD TO ME ESCAPING SO THAT YOUR VALVES SHOULD NOT BREAK CARRIED FROM HOUSE TO HOUSE TO SHIP FROM SAIL TO TRAIN BK SO THAT MY ENEMIES MIGHT GO ON TALKING TO ME NEAR MY BED TO MY PAIN BK THE LAST THING AT NIGHT THE FIRST THING IN THE MORNING OF THEIR VICTORIES AND OF MY CARES BK PROMISE ME NOT TO GO SILENT ALL OF A SUDDEN BK',
        estimatedSeconds: { wpm15: 75, wpm20: 56, wpm25: 45 },
        questions: [
            {
                id: 'radio-poem-q1',
                question: 'What is the "little box" referring to?',
                options: ['A MUSIC BOX', 'A RADIO', 'A TELEGRAPH', 'A SUITCASE'],
                answer: 'A RADIO',
                difficulty: 'Beginner'
            },
            {
                id: 'radio-poem-q2',
                question: 'Why does the speaker carry the box while escaping?',
                options: ['TO PROTECT IT', 'TO HEAR ENEMIES TALKING', 'TO LISTEN TO MUSIC', 'TO SELL IT'],
                answer: 'TO HEAR ENEMIES TALKING',
                difficulty: 'Intermediate'
            },
            {
                id: 'radio-poem-q3',
                question: 'When does the speaker listen to the box?',
                options: ['ONLY AT NIGHT', 'ONLY IN MORNING', 'LAST THING AT NIGHT AND FIRST IN MORNING', 'ALL DAY LONG'],
                answer: 'LAST THING AT NIGHT AND FIRST IN MORNING',
                difficulty: 'Intermediate'
            },
            {
                id: 'radio-poem-q4',
                question: 'What does the speaker fear the box might do?',
                options: ['EXPLODE', 'GO SILENT SUDDENLY', 'FALL AND BREAK', 'GET LOST'],
                answer: 'GO SILENT SUDDENLY',
                difficulty: 'Beginner'
            }
        ]
    }
];

export default {
    id: 'poem-radio-poem',
    type: 'poem',
    title: 'Radio Poem',
    author: 'Bertolt Brecht',
    publicationDate: '1938',
    coverImage: coverImg,
    genres: ['Poetry', 'War', 'Technology', 'Radio', 'History'],
    characterLength: SEGMENTS.reduce((acc, s) => acc + s.text.length, 0),
    description: "A poignant 1938 poem by Bertolt Brecht illustrating the reliance on the radio during wartime to hear news of the enemy's activities.",

    text: SEGMENTS.map(s => s.text).join('\n\n'),
    comprehensionQuestions: SEGMENTS.flatMap(s => s.questions),
    segments: SEGMENTS.map(s => ({
        ...s,
        comprehensionQuestions: s.questions.map(q => q.id)
    })),

    metadata: {
        setting: 'WWII Era / In Transit',
        period: '1938',
        themes: ['War', 'Anxiety', 'Technology', 'Exile'],
        difficulty: 'Beginner',
        estimatedReadingTimeMinutes: 1,
        stanzas: 1
    }
};
